import { forwardRef } from 'react';
import Divider, { DividerProps } from '@mui/material/Divider';

const AppBarDivider = forwardRef<HTMLHRElement, DividerProps>((props, ref) => {
  return (
    <Divider
      orientation="vertical"
      flexItem
      sx={{ marginTop: '8px', marginBottom: '8px', borderColor: 'rgba(255, 255, 255, 0.15)' }}
      ref={ref}
      {...props}
    />
  );
});

AppBarDivider.displayName = 'AppBar.Divider';
export default AppBarDivider;
